import React, {FC, useCallback} from 'react';
import {useDropsSubscriptionsContext} from '../../../../pages/Drops/context/SubscriptionsProvider';
import {useDropsTranslationContext} from '../../../../pages/Drops/context/TranslationProvider';
import StatusToast, {ToastTypes} from '../../../StatusToast/StatusToast';

interface DropToastProps {
  status: ToastTypes;
  isShown: boolean;
  isSubscribed: boolean;
  onClose: () => void;
}

export const DropToast: FC<DropToastProps> = ({
  status,
  isShown,
  isSubscribed,
  onClose,
}) => {
  const translations = useDropsTranslationContext();
  const {modalData} = useDropsSubscriptionsContext();

  const getToastText = useCallback(() => {
    if (status === 'SUCCESS') {
      if (isSubscribed || modalData.allDropsSubscriptionStatus) {
        return translations.overview.subscribe.modal.success.subscribe;
      }

      return translations.overview.subscribe.modal.success.unsubscribe;
    }

    return translations.overview.subscribe.modal.error;
  }, [status, translations, modalData, isSubscribed]);

  return (
    <StatusToast type={status} isShown={isShown} autoHide onAutoClose={onClose}>
      {getToastText()}
    </StatusToast>
  );
};
